import type { FaireProductEntity } from "../../entity_types/product";

export const apparel_socks_windowpane: FaireProductEntity = {
  token: "apparel-socks-windowpane",
  type: "product",
  name: "Window-Pane Socks",
  brandName: "Curated Basics",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/d644c5df31d79ec02f0d6ef50c8eb9756d2176d467e6b57bd02bd0679d0a8186.jpeg",
  priceDollars: 6,
  msrpDollars: 12,
  freeShipping: true,
  weight: 0.2,
  dimensions: {
    width: 4,
    height: 2,
    depth: 1,
  },
  description:
    "Bold window-pane plaid socks in vibrant colorways. 3-color assortment.",
  categoryTokens: ["cat_accessories"],
  tags: ["apparel", "socks", "colorful", "windowpane"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
